import { render, staticRenderFns } from "./u-swiper-pagination-text-divider.vue?vue&type=template&id=5b5c80de&scoped=true&"
import script from "./u-swiper-pagination-text-divider.vue?vue&type=script&lang=js&"
export * from "./u-swiper-pagination-text-divider.vue?vue&type=script&lang=js&"
import style0 from "./u-swiper-pagination-text-divider.vue?vue&type=style&index=0&id=5b5c80de&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b5c80de",
  null
  
)

export default component.exports